/* eslint-disable */
export default {
  _Background: 'Background',
  _Tree: 'Tree',
  _Grid_Bg: 'Grid_Bg',
  _FrontSnowbank: 'FrontSnowbank',
  _HUD_Snow: 'HUD_Snow',
  _HUD_Bg: 'HUD_Bg',
  _LABEL_Title: 'LABEL_Title',
  _Paused_Bg: 'Paused_Bg',
  _TitleOrnament: 'TitleOrnament',
  _Paused_Desktop: 'Paused_Desktop',
  _Paused_Mobile: 'Paused_Mobile',
  _TimerBar_Bg: 'TimerBar_Bg',
  _TitleOrnamentTextBg: 'TitleOrnamentTextBg',
  _TimerBar_RedStripe: 'TimerBar_RedStripe',
  _BUTTON_Play: 'BUTTON_Play',
  _BUTTON_Restart: 'BUTTON_Restart',
  _Paused_MenuButton: 'Paused_MenuButton',
  _Score_Bg: 'Score_Bg',
  _OrnamentSelector: 'OrnamentSelector',
  _Instruct: 'Instruct',
  _OrnamentSelector_Broken_2a: 'OrnamentSelector_Broken_2a',
  _Tile_001: 'Tile_001',
  _Tile_002: 'Tile_002',
  _Tile_003: 'Tile_003',
  _Tile_004: 'Tile_004',
  _Tile_005: 'Tile_005',
  _Tile_006: 'Tile_006',
  _Tile_007: 'Tile_007',
  _Tile_008: 'Tile_008',
  _Tile_009: 'Tile_009',
  _Tile_010: 'Tile_010',
  _Tile_011: 'Tile_011',
  _Tile_012: 'Tile_012',
  _Tile_013: 'Tile_013',
  _Tile_014: 'Tile_014',
  _Tile_015: 'Tile_015',
  _Flake1: 'Flake1',
  _Tile_016: 'Tile_016',
  _Tile_017: 'Tile_017',
  _Fake15: 'Fake15',
  _Tile_018: 'Tile_018',
  _Tile_019: 'Tile_019',
  _Fake2: 'Fake2',
  _Fake6: 'Fake6',
  _Fake7: 'Fake7',
  _Fake11: 'Fake11',
  _Fake14: 'Fake14',
  _Fake8: 'Fake8',
  _Tile_020: 'Tile_020',
  _LABEL_Level_2: 'LABEL_Level_2',
  _LABEL_Level_3: 'LABEL_Level_3',
  _Fake1: 'Fake1',
  _Fake5: 'Fake5',
  _LABEL_Level_1: 'LABEL_Level_1',
  _Fake10: 'Fake10',
  _Flake2: 'Flake2',
  _Tile_021: 'Tile_021',
  _Tile_022: 'Tile_022',
  _Tile_023: 'Tile_023',
  _Tile_024: 'Tile_024',
  _Tile_025: 'Tile_025',
  _Tile_026: 'Tile_026',
  _Tile_027: 'Tile_027',
  _Tile_028: 'Tile_028',
  _Tile_029: 'Tile_029',
  _Tile_030: 'Tile_030',
  _Tile_031: 'Tile_031',
  _Tile_032: 'Tile_032',
  _BUTTON_Menu: 'BUTTON_Menu',
  _LABEL_Score: 'LABEL_Score',
  _Tile_033: 'Tile_033',
  _Tile_034: 'Tile_034',
  _Tile_035: 'Tile_035',
  _Fake13: 'Fake13',
  _BUTTON_Audio_ON: 'BUTTON_Audio_ON',
  _BUTTON_Audio_OFF: 'BUTTON_Audio_OFF',
  _Gold_Dot_1: 'Gold_Dot_1',
  _ICON_Ornament: 'ICON_Ornament',
  _Flake3: 'Flake3',
  _Sparkle1: 'Sparkle1',
  _Fake3: 'Fake3',
  _Fake4: 'Fake4',
  _Fake9: 'Fake9',
  _Fake12: 'Fake12',
  _Glow1: 'Glow1',
  _GlowDot: 'GlowDot',
  _Pixel_1: 'Pixel_1',
  _Pixel_2: 'Pixel_2',
  _Pixel_3: 'Pixel_3',
  _test: 'test',
  _TileColorDot_001: 'TileColorDot_001',
  _TileColorDot_002: 'TileColorDot_002',
  _TileColorDot_003: 'TileColorDot_003',
  _TileColorDot_004: 'TileColorDot_004',
  _TileColorDot_005: 'TileColorDot_005',
}